export default "__VITE_ASSET__C$LIdS$m__"